import * as Sentry from '@sentry/vue'
import store from '@/store'

/**
 * Why this file? This removes the dependency on Util module, which is harmful to unit test
 */
export default {
  formatSlide: (slide) => {
    if (!slide.SlideOptions) {
      slide.SlideOptions = []
    }
    slide.SlideOptions.sort((a, b) => {
      return a.order - b.order
    })
    if (slide.hints && slide.hints.length) {
      slide.hints.sort((a, b) => {
        return a.order - b.order
      })
    }
    for (let i = 0; i < slide.SlideOptions.length; i++) {
      if (
        slide.SlideOptions[i].audience &&
        slide.SlideOptions[i].audience === store.state.audienceId
      ) {
        slide.openEndedSubmited = true
        break
      }
    }

    if (slide.answer && slide.answer.vote.length) {
      [slide.radioSelectded] = slide.answer.vote
    }

    try {
      slide.otherCorrectQuiz = JSON.parse(slide.otherCorrectQuiz)
    } catch (error) {
      Sentry.captureException(error)
      slide.otherCorrectQuiz = []
    }

    if (!slide.otherCorrectQuiz) {
      slide.otherCorrectQuiz = []
    }

    return slide
  },
}
